export const CURATED_LIST_TAB = {
    PROOFREADING: 'proofreading',
    AB_TESTS: 'abTests',
} as const;

export type CuratedListTab = (typeof CURATED_LIST_TAB)[keyof typeof CURATED_LIST_TAB];

export const DEFAULT_REFETCH_INTERVAL = 60000;
